document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const toggleScrolled = () => {
    body.classList.toggle('modus-scrolled', window.scrollY > 24);
  };

  toggleScrolled();
  window.addEventListener('scroll', toggleScrolled, { passive: true });

  const revealTargets = document.querySelectorAll(
    '.template-index .modus-home-hero__content, ' +
      '.template-index .modus-editorial-section, ' +
      '.template-index .modus-lifestyle-split, ' +
      '.template-collection .articleLookbook-block, ' +
      '.template-collection .toolbar, ' +
      '.template-collection #main-collection-product-grid .product'
  );

  if (!revealTargets.length) return;

  revealTargets.forEach((element, index) => {
    element.classList.add('modus-reveal');
    element.style.setProperty('--modus-reveal-delay', `${Math.min(index * 40, 240)}ms`);
  });

  if (!('IntersectionObserver' in window)) {
    revealTargets.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12
    }
  );

  revealTargets.forEach((element) => observer.observe(element));
});
